import { render, staticRenderFns } from "./SubMenuDots.vue?vue&type=template&id=768d3a1a"
import script from "./SubMenuDots.vue?vue&type=script&lang=js"
export * from "./SubMenuDots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports